// utils/themeUtils.js
export const themeToTranslationKey = {
  "Sucré": "SweetItem",
  "Salé": "SaltyItem",
  "Boisson (Matin)": "Beverage",
  "Boisson (Midi/Soir)": "Beverage",
  "Apéro": "Aperitif",
  "Entrée": "Starter",
  "Plat": "MainCourses",
  "Dessert": "Dessert"
};

export const getTranslatedTheme = (theme, t) => {
  const key = themeToTranslationKey[theme];
  return key ? t(key) : theme || t("NoTheme");
};
